import React from 'react';

import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const NumberLoading = (): any => (
  <ContentLoader width={20} height={10}>
    <rect width="20" height="10" />
  </ContentLoader>
);

export default NumberLoading;
